import classes from "./CartForm.module.css";
import { useState, useRef, useContext } from "react";
import { CartContext } from "../../CartContext";

const isEmpty = (value) => value.trim() === "";
const isEmail = (value) => value.trim().includes("@");
const is6CharLong = (value) => value.trim().length >= 6;
const isNumber = (value) => value.trim().length <= 14;

const CartForm = (props) => {
  const cartCtx = useContext(CartContext);
  const [formInputValidity, setFormInputValidity] = useState({
    name: true,
    email: true,
    street: true,
    postalCode: true,
    phoneNumber: true,
  });

  const nameRef = useRef();
  const emailRef = useRef();
  const streetRef = useRef();
  const postalCodeRef = useRef();
  const phoneNumberRef = useRef();

  const paymentHandler = (e) => {
    e.preventDefault();
    const enteredEmail = emailRef.current.value;
    const enteredName = nameRef.current.value;
    const enteredStreet = streetRef.current.value;
    const enteredPostalCode = postalCodeRef.current.value;
    const enteredPhoneNumber = phoneNumberRef.current.value;

    const enteredNameIsValid = !isEmpty(enteredName);
    const enteredEmailIsValid = isEmail(enteredEmail) && !isEmpty(enteredEmail);
    const enteredStreetIsValid =
      is6CharLong(enteredStreet) && !isEmpty(enteredStreet);
    const enteredPostalCodeIsValid =
      is6CharLong(enteredPostalCode) && !isEmpty(enteredPostalCode);
    const enteredPhoneNumberIsValid =
      !isEmpty(enteredPhoneNumber) && isNumber(enteredPhoneNumber);

    setFormInputValidity({
      name: enteredNameIsValid,
      email: enteredEmailIsValid,
      street: enteredStreetIsValid,
      postalCode: enteredPostalCodeIsValid,
      phoneNumber: enteredPhoneNumberIsValid,
    });

    if (!formInputValidity) {
      return;
    }

    const userData = {
      name: enteredName,
      email: enteredEmail,
      street: enteredStreet,
      postalCode: enteredPostalCode,
      phoneNumber: enteredPhoneNumber,
    };

    fetch("https://dc-luxury-default-rtdb.firebaseio.com/user.json", {
      method: "POST",
      body: JSON.stringify({
        id: props.id,
        name: enteredName,
        email: enteredEmail,
        street: enteredStreet,
        postalCode: enteredPostalCode,
        phoneNumber: enteredPhoneNumber,
        time: new Date(),
      }),
    });
    props.postCart();
  };

  return (
    <form className={classes.form}>
      <h3>Enter your delivery details</h3>
      <div className={classes.details}>
        <label htmlFor="name">Full Name</label>
        <input ref={nameRef} type="text" id="name" />
        {!formInputValidity.name && (
          <p className="invalid">Please Enter a Valid Name</p>
        )}
      </div>
      <div className={classes.details}>
        <label htmlFor="email">Email Address</label>
        <input ref={emailRef} type="email" id="email" />
        {!formInputValidity.email && (
          <p className="invalid">Please Enter a Valid Email (test@email.com)</p>
        )}
      </div>
      <div className={classes.details}>
        <label htmlFor="street">Enter Delivery Address</label>
        <input ref={streetRef} type="text" id="street" />
        {!formInputValidity.street && (
          <p className="invalid">Please Enter a Address</p>
        )}
      </div>
      <div className={classes.details}>
        <label htmlFor="code">Postal Code</label>
        <input ref={postalCodeRef} type="text" id="code" />
        {!formInputValidity.postalCode && (
          <p className="invalid">Please Enter a Valid Postal Code</p>
        )}
      </div>
      <div className={classes.details}>
        <label htmlFor="phone">Phone Number</label>
        <input ref={phoneNumberRef} type="text" id="phone" />
        {!formInputValidity.phoneNumber && (
          <p className="invalid">Please Enter a Valid Phone Number</p>
        )}
      </div>
      <button onClick={paymentHandler}>Proceed to payment</button>
    </form>
  );
};

export default CartForm;
